export enum EventsActionTypes{
    API_RESPONSE_SUCCESS = '@@service/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@service/API_RESPONSE_ERROR',

    GET_EVENTS= '@@service/GET_EVENTS',
    RESET = '@@service/RESET', 
    ADD_EVENTS='@@service/ADD_EVENTS',
    GET_EVENT_DETAILS = '@@service/GET_EVENT_DETAILS',
    UPDATE_EVENT = '@@service/UPDATE_EVENT',
    DELETE_EVENT = '@@service/DELETE_EVENT'
}